import { InMemoryCache } from '@apollo/client';
import { AttendeeConnectionStatus } from '@graphql/gql/graphql';
import { CacheIdentifier } from './types';

export const cacheIdentityAttendee = (id): CacheIdentifier => ({
  id,
  __typename: 'Attendee'
});

function alterAttendeeConnectionStatus(
  attendeeId: string,
  cache: InMemoryCache,
  connectionStatus: AttendeeConnectionStatus
): void {
  cache.modify({
    id: cache.identify(cacheIdentityAttendee(attendeeId)),
    fields: {
      connectionStatus(): AttendeeConnectionStatus {
        return connectionStatus;
      }
    }
  });
}

export function updateAttendeeToNotConnected(attendeeId: string, cache: InMemoryCache): void {
  alterAttendeeConnectionStatus(attendeeId, cache, AttendeeConnectionStatus.NotConnected);
}

export function updateAttendeeToPending(attendeeId: string, cache: InMemoryCache): void {
  alterAttendeeConnectionStatus(attendeeId, cache, AttendeeConnectionStatus.Pending);
}

export function updateAttendeeToConnected(attendeeId: string, cache: InMemoryCache): void {
  alterAttendeeConnectionStatus(attendeeId, cache, AttendeeConnectionStatus.Connected);
}

export function updateAttendeeToAwaitingResponse(attendeeId: string, cache: InMemoryCache): void {
  alterAttendeeConnectionStatus(attendeeId, cache, AttendeeConnectionStatus.AwaitingResponse);
}
